// extracted by mini-css-extract-plugin
export default {"modal":"approve-modal_modal__lsJ6x","titleSection":"approve-modal_titleSection__Awk+M","title":"approve-modal_title__0FM-p","fieldsSection":"approve-modal_fieldsSection__VuUVk"};